import React, { PropsWithChildren } from 'react';
import { Text, VStack } from '@wegroup/design-system';

interface Props {
  title: string;
}

const NavigationSection: React.FC<PropsWithChildren<Props>> = ({
  title,
  children,
}) => {
  return (
    <VStack spacing="2" align="stretch">
      <Text textStyle="normalBodyMedium" color="gray.500">
        {title}
      </Text>
      {children}
    </VStack>
  );
};

export default NavigationSection;
